import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {
  notificationsList: any[];
  login_Details: any;
  notificationVisible = true;
  notification: void;
  displayPosition: boolean;
  rows = [];
  searchQR: any;
  value1: any;
  rangeValues: number[] = [0,100];

  Finals_excel : any;

  Bank_list_gets : any;
  product_list_gets  : any;
  portfolio_list_gets  : any;
  Bank_list : any;
  portfolio_list : any;
  booleans : any;
  product_list : any;
  User_details1 : any;

  show_list : any = 'portfolio';

  loading: Boolean = false;





  Excel_Datas :  any;
  saved_Fields : any;

  saved_Fields1 : any = [];
  saved_Fields2 : any = [];




  user_list_details : any;
  Company_details : any;
  Designation_details2 : any;
  report_to : any;
  report_to_id : any;
  company_name : any;
  report_to_design : any;

  Designation_details1 : any;
  MyuploadList = [];
  tempDefs = [];
  columnDefs = [];
  dataLoaded: boolean;
  data = [];
  bankName: any;
  bankame: any;
  portfolio: any;
  product: any;


  timeLeft: number = 60;
  interval;
  bucket_details : any;

  bucket_detail : any;

  final_data : any;


  portfolio_bucket_id : any;
  transferData: any[];
  total_out_standing: number = 0;
  userFilter: any = { customer_id: '',acc_no:'',passport_no:'',total_out_standing:'',nationality : '',cycle : '',flow_status : '',customer_name : ''};
 
  constructor(private _api:ApiService,
     private router:Router,
      @Inject(SESSION_STORAGE) private storage: StorageService) { }

  ngOnInit(): void {
    this.getNotifications();
    this.getAllacation();
    

  }

  
  getAllacation(){
    
    this.bucket_details = new Date().getTime();
    window.scrollTo(0, 0);
    this.portfolio_bucket_id = this.getFromLocal("portfolio_bucket_id");


    let c  = {
      bucket_id : this.portfolio_bucket_id.bucket_id
    }
    this._api.fetch_bucket_details(c).subscribe(
      (response: any) => {
        this.bucket_detail = response.Data;
      }
    );



    let a  = {
      assigned_to : this.getFromLocal("User_ID"),
      client_id : this.getFromLocal("Client_ID"),
      bucket_id : this.portfolio_bucket_id.bucket_id
    }
    console.log("a",a);
    
    


    this._api.fetch_data_using_allocated_list_by_bucket(a).subscribe(
      (response: any) => {
        
        this.saved_Fields = response.Data;
        this.saved_Fields.forEach((item, i) => {
          let name =  JSON.parse(item.customer_details[0]);
        //  console.log("name",name);
          item.select_status = false;
          item.customer_name  = name[0].Customer_Name || '';
          item.customer_id = item.customer_id || ""
          item.passport_no = item.passport_no || ""
          item.acc_no = item.acc_no || ""
          item.agreement_id = item.agreement_id || ""
          item.cif = item.cif || ""
          item.total_out_standing = name[0][' total_out_standing '] || ""
          item.nationality = item.nationality || ""
          item.cycle = item.cycle  || ""
          item.flow_status = item.flow_status || ""
             this.total_out_standing = this.total_out_standing + item.total_out_standing  ;
            
          if(i == this.saved_Fields.length - 1){
            // console.log("DAtA in");
            this.loading = true;
            // console.log("this.saved_Fields.length",this.saved_Fields.length );
          }
        });
      console.log('test',this.saved_Fields);
      
        


      }
    );

  }
  getNotifications(){
    this.login_Details = this.getFromLocal("login_Details");
    const id = this.login_Details._id;
    
    this._api.getnotifcations_list(id).subscribe(data=>{
      if (data['Code'] == 200) {
        this.notificationsList = data['Data'];
          // this.notificationsList ==   this.saved_Fields
        console.log("getnotifcations_list" , this.notificationsList);
        
      } else {
        this.notificationsList = [];
      }
    });
  }
  viewnotification(url){
    console.log(url);
    this.router.navigateByUrl(url);
   
  }

  
  clearNotification(id: string) {
    this._api.delete_notifications(id).subscribe(() => {
      this.getNotifications();
    });
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }



  // getCustomer(page,data){
  //   let d = {
  //     passport_no :  data.passport_no,
  //     acc_no :  data.acc_no,
  //     bank_id : data.bank_id,
  //     portfolio_id :  data.porfolio_id,
  //     product_id : data.product_id,
  //     customer_id: data.customer_id,
  //     finterstal_id: data.finterstal_id
  //   }
  //   this._api.fetch_customer_detail1(d).subscribe(
  //     (response: any) => {
  //       console.log("response",response);

  //       if (response.Data[0].customer_details[0].insert_id != undefined) {
  //         var test_text = response.Data[0].customer_details;
  //         var convDatav = test_text;
  //         // console.log(convDatav['length']);
  //         var jsonObject = convDatav[0];
  //         var keyCount  = Object.keys(jsonObject).length;
  //         // console.log(keyCount);
  //         let dataList = [];
  //         for (let i = 0; i < convDatav.length; i++) {
  //               for (let i = 0; i < keyCount; i++) {
  //                 var key = Object.keys(jsonObject)[i];
  //                 if (key == "assigned_by" || key == "Acc_no" || key == "Account_No"  || key == "Bank_ID"  ||  key == "Portfolio_ID"  || key == "") {
                    
  //                 } else {
  //                   var value = jsonObject[key];
  //                   dataList.push({column:key,row:value});
  //                 }
  //               }
  //             }
  //           this.storage.set("_storedRecord",{dataList,"keyvalue":data});
  //           this.router.navigateByUrl(page);
  //       } else {
  //         console.log(response.Data[0].customer_details[0]);
  //         var test_text;
  //         console.log(response.Data[0].customer_details[0].passport_no);
  //         console.log(response.Data[0].customer_details[0].passport_no);
  //         if(response.Data[0].customer_details[0].passport_no !== undefined){
  //           test_text = [];
  //           test_text.push(response.Data[0].customer_details[0]);
  //         }else{
  //           test_text = JSON.parse(response.Data[0].customer_details[0]);
  //         }
  //         let convDatav = test_text;
  //         // console.log(convDatav['length']);
  //         var jsonObject = convDatav[0];
  //         var keyCount  = Object.keys(jsonObject).length;
  //         // console.log(keyCount,"121");
  //         let dataList = [];
      
          
  //         for (let i = 0; i < convDatav.length; i++) {
  //               for (let i = 0; i < keyCount; i++) {
  //                 var key = Object.keys(jsonObject)[i];
  //                 if (key == "assigned_by" || key == "Acc_no" || key == "Account_No"  || key == "Bank_ID"  ||  key == "Portfolio_ID"  || key == "") {
                    
  //                 } else {
  //                   var value = jsonObject[key];
  //                   dataList.push({column:key,row:value});
  //                 }
  //               }
  //             }
  //           this.storage.set("_storedRecord",{dataList,"keyvalue":data});
  //           this.router.navigateByUrl(page);
  //           console.log("page",page);
            
  //       }

    
  //     }
  //   );
  // }

  getCustomer(page,data){
    console.log("page",data);
    // debugger
    let d = {
      passport_no :  data.passport_no,
      acc_no :  data.acc_no,
      bank_id : data.bank_id,
      portfolio_id :  data.porfolio_id,
      product_id : data.product_id,
      customer_id: data.customer_id,
      finterstal_id: data.finterstal_id
    }
    console.log("d",d);
    this._api.fetch_customer_detail2(d).subscribe(
      (response: any) => {
        console.log("response",response);
        if (response['Code'] == 200) {
          var notification = response['Data'][0].customer_details[0];
         
          // notification.forEach(element => {
          //   let name = JSON.parse(element.customer_details[0]);
          //   element.customer_name1 = name.Customer_Name || '';
           

          // });
          console.log(notification, '123');
// debugger
        if (notification.customer_details[0].insert_id != undefined) {
          var test_text = notification.customer_details[0];
          var convDatav = test_text;
          //  console.log(convDatav['length']);
          var jsonObject = convDatav[0];
          var keyCount  = Object.keys(jsonObject).length;
          //  console.log(keyCount);
          let dataList = [];
          for (let i = 0; i < convDatav.length; i++) {
                for (let i = 0; i < keyCount; i++) {
                  var key = Object.keys(jsonObject)[i];
                  if (key == "assigned_by" || key == "Acc_no" || key == "Account_No"  || key == "Bank_ID"  ||  key == "Portfolio_ID"  || key == "") {
                    
                  } else {
                    var value = jsonObject[key];
                    dataList.push({column:key,row:value});
                  }
                }
              }
            this.storage.set("_storedRecord",{dataList,"keyvalue":data});
            this.router.navigateByUrl(page);
        } else {
          // debugger
          // console.log(notification.customer_details[0]);
          var test_text;
          if(notification.customer_details[0].finterstal_id !== undefined){
            test_text = [];
            test_text.push(notification.customer_details[0]);
          }else{
            test_text = JSON.parse(notification.customer_details[0]);
          }
          let convDatav = test_text;
          // console.log(convDatav['length']);
          var jsonObject = convDatav[0];
          var keyCount  = Object.keys(jsonObject).length;
          // console.log(keyCount,"121");
          let dataList = [];
      
          
          for (let i = 0; i < convDatav.length; i++) {
                for (let i = 0; i < keyCount; i++) {
                  var key = Object.keys(jsonObject)[i];
                  if (key == "assigned_by" || key == "Acc_no" || key == "Account_No"  || key == "Bank_ID"  ||  key == "Portfolio_ID"  || key == "") {
                    
                  } else {
                    var value = jsonObject[key];
                    dataList.push({column:key,row:value});
                  }
                }
              }
            this.storage.set("_storedRecord",{dataList,"keyvalue":data});
            this.router.navigateByUrl(page);
            console.log("page",page);
            
        }
      }
    
      }
    );
  }


  getCustomer1(page,data){
    // console.log(page,data);
    let d = {
      passport_no :  data.passport_no,
      acc_no :  data.acc_no,
      bank_id : data.bank_id,
      portfolio_id :  data.porfolio_id,
      product_id : data.product_id,
      customer_id: data.customer_id,
      finterstal_id: data.finterstal_id,

    }
    // console.log(d);
    this._api.fetch_customer_detail1(d).subscribe(
      (response: any) => {
       
        // console.log("response",response);

        if (response.Data[0].customer_details[0].insert_id != undefined) {
          var test_text = response.Data[0].customer_details;
          var convDatav = test_text;
          // console.log(convDatav['length']);
          var jsonObject = convDatav[0];
          var keyCount  = Object.keys(jsonObject).length;
          // console.log(keyCount);
          let dataList = [];
          for (let i = 0; i < convDatav.length; i++) {
                for (let i = 0; i < keyCount; i++) {
                  var key = Object.keys(jsonObject)[i];
                  if (key == "assigned_by" || key == "Acc_no" || key == "Account_No"  || key == "Bank_ID"  ||  key == "Portfolio_ID"  || key == "") {
                    
                  } else {
                    var value = jsonObject[key];
                    dataList.push({column:key,row:value});
                  }
                }
              }
            this.storage.set("_storedRecord",{dataList,"keyvalue":data});
            this.router.navigateByUrl(page);
        } else {
          // console.log(response.Data[0].customer_details[0]);
          var test_text;
          // console.log(response.Data[0].customer_details[0].passport_no);
          // console.log(response.Data[0].customer_details[0].passport_no);
          if(response.Data[0].customer_details[0].passport_no !== undefined){
            test_text = [];
            test_text.push(response.Data[0].customer_details[0]);
          }else{
            test_text = JSON.parse(response.Data[0].customer_details[0]);
          }
          let convDatav = test_text;
          // console.log(convDatav['length']);
          var jsonObject = convDatav[0];
          var keyCount  = Object.keys(jsonObject).length;
          // console.log(keyCount);
          let dataList = [];
          for (let i = 0; i < convDatav.length; i++) {
                for (let i = 0; i < keyCount; i++) {
                  var key = Object.keys(jsonObject)[i];
                  if (key == "assigned_by" || key == "Acc_no" || key == "Account_No"  || key == "Bank_ID"  ||  key == "Portfolio_ID"  || key == "") {
                    
                  } else {
                    var value = jsonObject[key];
                    dataList.push({column:key,row:value});
                  }
                }
              }
            this.storage.set("_storedRecord",{dataList,"keyvalue":data});
            this.router.navigateByUrl(page);
            console.log("page",page);
            
        }

    
      }
    );
  }
  

  fetchuser_1(){

    let req = {
      "bankname" : "",
      "designation" : this.report_to_design.y
    }
    this._api.user_details_list_by_com(req).subscribe(
      (response: any) => {
        if(response.Data.length == 0){
         alert("There is no user with this designations");
        }else {
          this.User_details1 = [];
          for(let a = 0 ; a < response.Data.length; a++){
            let x =  { 'y': response.Data[a].email_id}
            this.User_details1.push(x);
          }
          this.User_details1 = this.User_details1.reverse();
        }
      }
    );
  }


  Report_fetch(){
    for(let a = 0 ; a < this.user_list_details.length; a++){
      if(this.user_list_details[a].email_id == this.report_to.y){
         this.report_to_id = this.user_list_details[a]._id;
      }
    }
  }

  saveInLocal(key, val): void {
    this.storage.set(key, val);
  }

  toggleEditable(status: any, index: any){
   this.saved_Fields[index].select_status = status;
  }

 

  Change_list(item){
    this.show_list = item;
    console.log("show_list",this.show_list);
  }



}
